import { http } from '@/api/client/httpClient';
import type { Select2Option } from '@/components/forms/Select2';
import type { LpMarginThresholdProfileDto, LpMarginThresholdSaveDto } from '@/api/types/lpMarginThreshold';

const BASE = '/api/app/lp-margin-threshold';

export const lpMarginThresholdApi = {
  async getList(): Promise<LpMarginThresholdProfileDto[]> {
    const { data } = await http.get<{ items: LpMarginThresholdProfileDto[] }>(BASE, {
      params: { skipCount: 0, maxResultCount: 1000 },
    });
    return data.items ?? [];
  },
  async getLpAccounts(): Promise<Select2Option[]> {
    const { data } = await http.get<{ value: string | number; text: string }[]>(`${BASE}/lp-accounts`);
    return (data ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
  async save(dto: LpMarginThresholdSaveDto): Promise<void> {
    await http.post(`${BASE}/save`, dto);
  },
  async remove(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  },
  async toggle(id: number, isActive: boolean): Promise<void> {
    await http.post(`${BASE}/${id}/toggle`, null, { params: { isActive } });
  },
};
